import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from 'config';
import WebpackUtils from '../../utils/WebpackUtils';
import { setSendEventsArr } from '../../redux_stores/analyticsReducer/actions';
import { setAnalyticsEnabled } from '../../redux_stores/componentConfigReducer/actions';

const AnalyticsLayer = ({ locale }) => {
	const storeName = useSelector((state) => state?.storeData?.name);
	const measurementID = useSelector(
		(state) => state?.storeData?.google_analytics?.measurement_id,
	);
	const analyticsModules = useSelector(
		(state) => state?.componentConfig?.analyticsModules || [],
	);

	const dispatch = useDispatch();

	const enableAnalytics = () => {
		dispatch(setAnalyticsEnabled(true));
	};

	const loadModuleScript = (scope, module, analyticsData) => {
		WebpackUtils.loadComponent(scope, module).then((factory) => {
			const { load, sendEvent } = factory.default;
			load(config.ENV, storeName, analyticsData, locale, enableAnalytics);
			dispatch(setSendEventsArr(sendEvent));
		});
	};

	useEffect(() => {
		if (storeName) {
			analyticsModules.forEach((analyticsModule) => {
				const { remoteConfig, properties } = analyticsModule;
				const { url, scope, module } = remoteConfig;
				const { additionalAnalyticsIDs } = properties;

				const analyticsData = {
					measurementID,
					additionalAnalyticsIDs,
				};

				const element = WebpackUtils.createElement(url, () =>
					loadModuleScript(scope, module, analyticsData),
				);
				document.head.appendChild(element);
			});
		}
	}, [storeName]);

	return null;
};

export default AnalyticsLayer;
